import React from 'react';

const Card = ({children}) => {

    return <div className={`w-full p-5 rounded-xl surface-1 surface-outline shadow-lg`}>
        {children}
    </div>
}

export default Card;
